import { HStack, VStack, Button, Text } from '@cad-arc';
import { ContactListProfileView } from '@mark43/cad-api';
import { Controller, useFieldArray, UseFormReturn } from 'react-hook-form';
import { FormAttributeSelect } from '../forms/integrated-form-controls/form-attribute-select';
import { FormInput } from '../forms/integrated-form-controls/form-input';

export function ContactForm(props: {
    form: UseFormReturn<ContactListProfileView, any>;
}): React.ReactElement {
    const form = props.form;
    const { fields, append, remove } = useFieldArray({
        control: form.control,
        name: 'secondaryRolodexContacts',
    });
    return (
        <VStack width="360px" alignItems="flex-start">
            <Text variant="headingSm">Organization</Text>
            <FormInput
                name="name"
                label="Org Name"
                control={form.control}
                rules={{ required: 'Required' }}
            />
            <FormAttributeSelect
                attributeType="ROLODEX_PROFILE_TYPE"
                name="rolodexProfileTypeAttr"
                label="Category"
                control={form.control}
                rules={{ required: 'Required' }}
            />
            <FormInput name="address" label="Address" control={form.control} />
            <Text variant="headingSm">Primary Contact</Text>
            <HStack alignItems="flex-start">
                <FormInput
                    name="primaryRolodexContact.name"
                    label="Name"
                    control={form.control}
                    rules={{ required: 'Required' }}
                />
                <FormInput
                    name="primaryRolodexContact.phoneNumber"
                    label="Phone"
                    rules={{
                        maxLength: {
                            value: 30,
                            message: 'Must be 30 characters or less',
                        },
                    }}
                    control={form.control}
                />
            </HStack>
            <FormInput name="primaryRolodexContact.note" label="Notes" control={form.control} />
            <Text variant="headingSm">Secondary Contact(s)</Text>
            <Controller
                name="secondaryRolodexContacts"
                control={form.control}
                render={() => (
                    <VStack w="100%" alignItems="flex-start" spacing="4">
                        {fields.map((field, index) => (
                            <Controller
                                key={field.id}
                                name={`secondaryRolodexContacts.${index}`}
                                control={form.control}
                                render={() => (
                                    <HStack w="100%" alignItems="flex-start">
                                        <VStack>
                                            <HStack alignItems="flex-start">
                                                <FormInput
                                                    name={`secondaryRolodexContacts.${index}.name`}
                                                    label="Name"
                                                    control={form.control}
                                                    rules={{ required: 'Required' }}
                                                />
                                                <FormInput
                                                    name={`secondaryRolodexContacts.${index}.phoneNumber`}
                                                    label="Phone"
                                                    control={form.control}
                                                />
                                            </HStack>
                                            <FormInput
                                                name={`secondaryRolodexContacts.${index}.note`}
                                                label="Notes"
                                                control={form.control}
                                            />
                                        </VStack>
                                        <Button
                                            variant="ghost"
                                            leftIcon="TrashCan"
                                            onClick={() => {
                                                remove(index);
                                            }}
                                        />
                                    </HStack>
                                )}
                            />
                        ))}
                        <Button
                            variant="ghost"
                            leadingVisual="Add"
                            data-testid="add-personnel-button"
                            onClick={() =>
                                append(
                                    // @ts-expect-error TODO: CAD-21824 fix type
                                    {
                                        name: '',
                                        phoneNumber: '',
                                        note: '',
                                    }
                                )
                            }
                        >
                            Contact
                        </Button>
                    </VStack>
                )}
            />
        </VStack>
    );
}
